const autoNgTemplateLoaderTemplate1 = require('./roles.html');

import controller from './roles.controller';

export const rolesView = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
